import { useQueryClient } from 'react-query'
import { featureFlagQueryKey } from './helpers'
import { FeatureFlagName, FeatureFlagResponse } from './types'
import { featureFlags } from './featureFlags'
import { useTypedSelector } from 'hooks/useTypedSelector'

export const useFeatureFlag = (flagName: FeatureFlagName) => {
  const { profile } = useTypedSelector(({ user }) => user)
  const queryClient = useQueryClient()
  const flag = featureFlags.find((o) => o.name === flagName)
  const enabled = !!flag?.enabled
  const isInternalUser = profile?.data?.email?.includes('@fable.co')

  if (flag?.isStatic) return enabled && isInternalUser

  const flagsQuery = queryClient.getQueryData<FeatureFlagResponse>([
    featureFlagQueryKey,
  ])

  const flags = flagsQuery?.data?.feature_flags || []

  return flags.includes(flagName) && enabled
}
